import { cn } from '../lib/utils';

interface AvatarCircleProps {
  name: string;
  src?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'hero' | 'xl';
  className?: string;
}

const SIZE_CLASSES = {
  xs: 'w-6 h-6 text-[10px]',
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-14 h-14 text-base',
  /** 80 px — en-tête d'écran (ex. interlocuteur d'une discussion). */
  hero: 'w-20 h-20 text-xl',
  xl: 'w-24 h-24 text-2xl',
};

function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .map((w) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function AvatarCircle({ name, src, size = 'md', className }: AvatarCircleProps) {
  const sizeClass = SIZE_CLASSES[size];
  return (
    <div
      className={cn(
        'flex flex-shrink-0 items-center justify-center overflow-hidden rounded-full',
        sizeClass,
        className,
      )}
    >
      {src ? (
        <img src={src} alt={name} className="h-full w-full object-cover" />
      ) : (
        <div
          className={cn(
            'flex h-full w-full items-center justify-center',
            'bg-primary-100 text-primary-700 font-semibold',
            sizeClass,
          )}
        >
          {initials(name)}
        </div>
      )}
    </div>
  );
}
